/* eslint-disable react/destructuring-assignment,react/prop-types,
react/no-array-index-key,react/no-did-update-set-state */
// Copyright (c) 2019 Deere & Company

import {
    ErrorAlertBar, InfoAlertBar, SuccessAlertBar, WarningAlertBar,
} from '../alert-bar';
import React from 'react';
import { connect } from 'react-redux';
import { discardMessages } from '../../action-creators/alert-messages';
import { withRouter } from 'react-router-dom';

const alertBarMap = {
    Success: SuccessAlertBar,
    Error: ErrorAlertBar,
    Information: InfoAlertBar,
    Warning: WarningAlertBar,
};

const getAlertMessage = (reference, message) => (reference.length > 0 ? `${reference}. ${message}` : message);

export class WarrantyAlertBarBase extends React.Component {

    state = {
        alerts: [],
    };

    componentDidMount() {

        this.unlisten = this.props.history && this.props.history.listen(() => {

            if (this.state.alerts.length > 0) {

                this.setState({
                    alerts: [],
                });
                this.props.discardMessages();

            }

        });

    }

    componentDidUpdate(prevProps) {

        if (prevProps.alerts !== this.props.alerts) {

            this.setState({
                alerts: this.props.alerts,
            });

        }

    }

    componentWillUnmount() {

        this.unlisten();

    }

    render() {

        const showAlerts = this.state.alerts.length !== 0 && !this.props.isApplicationLoading;
        const AlertBarComponent = showAlerts && alertBarMap[this.state.alerts[0].type];

        return (
            <>
                {this.props.children}
                {showAlerts && (
                    <AlertBarComponent
                        alertTitle={this.state.alerts[0].type}
                        dismissHandler={this.props.discardMessages}
                    >
                        <ul>
                            {this.state.alerts.map((alert, index) => (
                                <li key={index}>
                                    {getAlertMessage(alert.reference, alert.message)}
                                </li>
                            ))}
                        </ul>
                    </AlertBarComponent>
                )}
            </>
        );

    }

}

const mapStateToProps = (state) => ({
    isApplicationLoading: state.application.busyCounter,
    alerts: state.application.alerts,
});

export const WarrantyAlertBar = connect(
    mapStateToProps,
    {
        discardMessages,
    },
)(withRouter(WarrantyAlertBarBase));
